<!--
 * @Author: john 285342894@qq.com
 * @Date: 2024-01-25 21:03:12
 * @LastEditors: john 285342894@qq.com
 * @LastEditTime: 2024-11-23 16:53:00
 * @FilePath: \account\src\pages\setting\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<a-layout>
			<a-layout-sider style="background: #FFFFFF;overflow: hidden; height: 100vh;" width="200px">
				<div style="padding: 30px 10px;">
                    <div class="second-menu-item" style="padding:0 10px;" :class="{on:getSelectKey.indexOf('account') > -1}"  @click="toSetting(1)">
                        <i class="iconfont icontabbar031 ft14"></i>
                        <span class="ft14 ml10">用户管理</span>
                    </div>
                    <div  class="second-menu-item" style="padding:0 10px;" :class="{on:getSelectKey.indexOf('setting_role') > -1}" @click="toSetting(2)">
                        <i class="iconfont 	iconadminister ft14"></i>
                        <span class="ft14 ml10">角色管理</span>
                    </div>
                    <div v-if="isShowDataRole" style="padding:0 10px;" class="second-menu-item" :class="{on:getSelectKey.indexOf('data_role') > -1}" @click="toSetting(3)">
                        <i class="iconfont 		icondatarole02 ft14"></i>
                        <span class="ft14 ml10">数据角色管理</span>
                    </div>	
                    <div v-if="isShowShop" style="padding:0 10px;" class="second-menu-item" :class="{on:getSelectKey.indexOf('shop') > -1}" @click="toSetting(4)">
                        <i class="iconfont 	iconshop ft14"></i>
                        <span class="ft14 ml10">店铺管理</span>
                    </div>
                    <div class="second-menu-item" style="padding:0 10px;" :class="{on:getSelectKey.indexOf('wechat') > -1}" @click="toSetting(5)">
                        <i class="iconfont 	iconweixin_gray ft14"></i>
                        <span class="ft14 ml10">微信公众平台配置</span>
                    </div>
                    <div class="second-menu-item" style="padding:0 10px;" :class="{on:getSelectKey.indexOf('wxuser') > -1}" @click="toSetting(6)">
                        <i class="iconfont 	iconpartner_client ft14"></i>
                        <span class="ft14 ml10">公众号关注列表</span>
                    </div>		
				</div>
			</a-layout-sider>
			<a-layout-content style="padding: 30px 20px; min-height:100px; background: #F7F8FA;">
				<router-view></router-view>
			</a-layout-content>
		</a-layout>
	</div>
</template>

<script>
	export default {
		
		data() {
			return {
                active:1,
                isShowDataRole: false,
                isShowShop: false,
			}
		},
        components:{
        },
        created(){
            this.init();
        },
		methods: {
            init(){
                if(this.loading==true) return;
				this.loading=true;
				this.$http.api('platform/account/getAccountAppIdenList',{
				}).then(res=>{
					if(res.data == 1){
                        this.isShowDataRole = true;
                    }
                    if(res.shop == 1){
                        this.isShowShop = true;
                    }
					this.loading=false;
				}).catch(res=>{
					this.loading=false;
				})
            },
			toSetting(index){
                this.active = index;
                switch (index){
                    case 2:
                        this.$router.push('/setting/roles/index');
                        break;
                    case 3:
                        this.$router.push('/setting/roles/data');
                        break;
                    case 4:
                        this.$router.push('/setting/shop');
                        break; 
                    case 5:
                        this.$router.push('/setting/wechat/index');
                        break; 
                    case 6:
                        this.$router.push('/setting/wechat/user');
                        break;               
                    default:
                        this.$router.push('/setting/account')
                        break;   
                }
            },
		}
	}
</script>

<style>
	.second-menu-item.on{
        background: rgba(86, 122, 240, 0.06);
        color:#567AF0;
    }
</style>
